<div
  class="column-filter-editor-container"
  tabindex="-1"
  (click)="$event.stopPropagation()"
  (keydown)="onKeydown($event)"
>
  @switch (config.type) {
    @case ('text') {
      <div class="editor-section text-editor-section">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="full-width-field">
          <mat-label>{{ config.columnLabel }}</mat-label>
          <input
            matInput
            type="text"
            [formControl]="textControl"
            [placeholder]="config.placeholder || 'Filter by ' + config.columnLabel + '...'"
            [attr.aria-label]="'Filter by ' + config.columnLabel"
          />
          @if (textControl.value) {
            <button mat-icon-button matSuffix type="button" (click)="textControl.setValue('')" aria-label="Clear input">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    }

    @case ('categorical') {
      <div class="editor-section categorical-editor-section">
        @if (normalizedOptions.length === 0) {
          <p class="empty-options-hint">No filter options available</p>
        } @else {
          <mat-selection-list
            [formControl]="categoricalControl"
            class="categorical-list"
            [attr.aria-label]="'Select ' + config.columnLabel + ' options'"
          >
            @for (opt of normalizedOptions; track opt.value) {
              <mat-list-option [value]="opt.value" class="filter-list-option">
                @if (opt.chipClass) {
                  <span class="filter-chip" [ngClass]="opt.chipClass">{{ opt.label }}</span>
                } @else {
                  <span class="option-label">{{ opt.label }}</span>
                }
              </mat-list-option>
            }
          </mat-selection-list>
        }
      </div>
    }

    @case ('date-range') {
      <div class="editor-section date-range-editor-section">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="date-field">
          <mat-label>From date</mat-label>
          <input matInput type="date" [formControl]="startDateControl" aria-label="Filter from date" />
          @if (startDateControl.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="startDateControl.setValue('')"
              aria-label="Clear start date"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="date-field">
          <mat-label>To date</mat-label>
          <input matInput type="date" [formControl]="endDateControl" aria-label="Filter to date" />
          @if (endDateControl.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="endDateControl.setValue('')"
              aria-label="Clear end date"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    }

    @case ('number-range') {
      <div class="editor-section number-range-editor-section">
        @if (config.targetOptions && config.targetOptions.length > 1) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="full-width-field target-field">
            <mat-label>Criterion applies to</mat-label>
            <mat-select [formControl]="targetControl">
              @for (targetOpt of config.targetOptions; track targetOpt.value) {
                <mat-option [value]="targetOpt.value">{{ targetOpt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else if (config.targetLabel) {
          <div class="target-label" role="note">{{ config.targetLabel }}</div>
        }

        <div class="range-inputs-row">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="range-field">
            <mat-label>Min</mat-label>
            <input
              matInput
              type="number"
              min="0"
              [formControl]="minControl"
              placeholder="0"
              aria-label="Minimum value"
            />
            @if (minControl.value !== null && minControl.value !== '') {
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="minControl.setValue(null)"
                aria-label="Clear min"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="range-field">
            <mat-label>Max</mat-label>
            <input
              matInput
              type="number"
              min="0"
              [formControl]="maxControl"
              placeholder="Any"
              aria-label="Maximum value"
            />
            @if (maxControl.value !== null && maxControl.value !== '') {
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="maxControl.setValue(null)"
                aria-label="Clear max"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
      </div>
    }
  }
</div>
